<section class="left-nav-wrapper scroll-container">
  <div class="d-flex">
    <h1 class="page-title me-auto">Company</h1>
  </div>
  <div class="row">
    <div class="col-lg-12 col-xl-6">
      <div class="card">
        <div class="card-body">
          <button
            cpGTagEvent
            [params]="{ event_label: 'company_home_create_subtask' }"
            type="button"
            class="btn btn-primary float-end"
            (click)="createSubTask(content)">
            <i class="fas fa-xs fa-plus"></i>&nbsp;Add Subtask
          </button>
          <h3 class="card-title">Payroll Subtasks</h3>
          <h5 class="mb-1">Before Payroll</h5>
          <div *ngIf="bpSubTasks.length == 0">
            <em><small>No Before Payroll Subtasks</small></em>
          </div>
          <div
            style="min-height: 50px; cursor: pointer"
            id="drop-list-1"
            cdkDropList
            #bpDropList="cdkDropList"
            [cdkDropListConnectedTo]="apDropList"
            [cdkDropListData]="bpSubTasks"
            class="mt-2 mb-4"
            (cdkDropListDropped)="dropSubTask($event)">
            <div
              class="row"
              *ngFor="let task of bpSubTasks"
              cdkDrag
              style="border: 1px solid #dee2e6; background: #fff">
              <div class="col-1 py-2">
                <i class="fas fa-bars"></i>
              </div>
              <div class="col-8 py-2">
                {{ task.Description }}
              </div>
              <div class="col-3">
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'company_home_delete_subtask' }"
                  class="btn btn-link"
                  (click)="deleteSubTask(task)">
                  Delete
                </button>
                &nbsp;|&nbsp;
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'company_home_edit_subtask' }"
                  class="btn btn-link"
                  (click)="editSubTask(content, task)">
                  Edit
                </button>
              </div>
            </div>
          </div>
          <h5 class="mb-1">After Payroll</h5>
          <div *ngIf="apSubTasks.length == 0">
            <em><small>No After Payroll Subtasks</small></em>
          </div>
          <div
            id="drop-list-2"
            style="min-height: 50px; cursor: pointer"
            cdkDropList
            #apDropList="cdkDropList"
            [cdkDropListData]="apSubTasks"
            [cdkDropListConnectedTo]="bpDropList"
            class="mt-2"
            (cdkDropListDropped)="dropSubTask($event)">
            <div
              class="row"
              *ngFor="let task of apSubTasks"
              cdkDrag
              style="border: 1px solid #dee2e6; background: #fff">
              <div class="col-1 py-2">
                <i class="fas fa-bars"></i>
              </div>
              <div class="col-8 py-2">
                {{ task.Description }}
              </div>
              <div class="col-3">
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'company_home_delete_subtask' }"
                  class="btn btn-link"
                  (click)="deleteSubTask(task)">
                  Delete
                </button>
                &nbsp;|&nbsp;
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'company_home_edit_subtask' }"
                  class="btn btn-link"
                  (click)="editSubTask(content, task)">
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-xl-6">
      <div class="card">
        <div class="card-body">
          <button
            type="button"
            cpGTagEvent
            [params]="{ event_label: 'company_home_edit_note' }"
            class="btn btn-primary float-end"
            routerLink="/client/{{ clientCode }}/notes">
            Edit Note
          </button>
          <h3 class="card-title">Client Notes</h3>
          <ng-container
            *ngIf="clientNote && clientNote.Note; then displayNote; else noNote"></ng-container>
          <ng-template #displayNote>
            <label>{{ clientNote.Note }}</label>
          </ng-template>
          <ng-template #noNote>
            <em><small>No active client note</small></em>
          </ng-template>
        </div>
      </div>
    </div>
    <div *ngIf="showWebclock" class="col-lg-12 col-xl-6">
      <div class="card">
        <div class="card-body">
          <button
            type="button"
            class="btn btn-primary float-end"
            (click)="createSwipeclockMapping(swipeclockMapping)">
            {{ isMappedToSwipeclock ? 'Update Mapping' : 'Add Mapping' }}
          </button>
          <h3 class="card-title">Swipeclock Site Mapping</h3>
          <em
            ><small>{{ isMappedToSwipeclock ? 'Mapped to site' : 'Not mapped' }}</small></em
          >
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-xl-6">
      <div class="card">
        <div class="card-body">
          <button
            type="button"
            class="btn btn-primary float-end"
            (click)="isClientWhitelisted(clientWhitelist)">
            {{ isWhitelisted ? 'Disable' : 'Enable' }}
          </button>
          <h3 class="card-title">Client Access to Relay Employee Portal</h3>
          <em
            ><small>{{ isWhitelisted ? 'Enabled' : 'Disabled' }}</small></em
          >
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Payroll Subtask</h4>
    <button
      cpGTagEvent
      [params]="{ event_label: 'company_home_payroll_subtask_modal_dismiss' }"
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form *ngIf="subTaskForm" [formGroup]="subTaskForm" class="padded-form">
      <div class="row">
        <div class="col-lg-6">
          <label>Task Group</label>
          <select appAutoFocus formControlName="TaskGroupId" class="form-control">
            <option value="1">Before Payroll</option>
            <option value="2">After Payroll</option>
          </select>
          <div *ngIf="form.TaskGroupId.errors?.required" class="input-error">*required</div>
        </div>
        <div class="col-lg-6">
          <label>Position in Group</label>
          <input formControlName="Position" class="form-control stepped" type="number" />
          <div *ngIf="form.Position.errors?.required" class="input-error">*required</div>
        </div>
        <div class="col-lg-12">
          <label>Description</label>
          <input formControlName="Description" class="form-control" />
          <div *ngIf="form.Description.errors?.required" class="input-error">*required</div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      cpGTagEvent
      [params]="{ event_label: 'company_home_payroll_subtask_modal_cancel' }"
      type="button"
      class="btn btn-secondary"
      (click)="modal.dismiss()">
      Cancel
    </button>
    <div (mouseenter)="markGroupTouched(subTaskForm)">
      <button
        cpGTagEvent
        [params]="{ event_label: 'company_home_payroll_subtask_modal_save' }"
        type="button"
        class="btn btn-primary"
        (click)="modal.close()"
        [disabled]="!subTaskForm.valid">
        Save Subtask
      </button>
    </div>
  </div>
</ng-template>
<ng-template #swipeclockMapping let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Swipeclock Site Mapping</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-lg-12">
      <label>Site Id</label>
      <input class="form-control" type="number" [(ngModel)]="siteId" />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <div>
      <button type="button" class="btn btn-primary" (click)="modal.close()">Save</button>
    </div>
  </div>
</ng-template>
<ng-template #clientWhitelist let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Client Access to Relay Employee Portal</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-lg-10">
      <input type="checkbox" (click)="onChange()" [(ngModel)]="userWhitelistValue" value="true" />
      <label><span></span>&nbsp; Client access </label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <div>
      <button [disabled]="disabled" type="button" class="btn btn-primary" (click)="modal.close()">
        Save
      </button>
    </div>
  </div>
</ng-template>
